
    import { Vue,Component } from 'vue-property-decorator'
    import { State, Action, namespace, Getter } from 'vuex-class'
    import PagedTable from '../../components/common/pagedTable.vue'
    import Partner from '../../components/partner.vue'
    import exicon from '../../assets/expressicon'
    const recharge = namespace('recharge')

    @Component({
        components: {
            PagedTable,
            Partner
        }
    })
    export default class Recharge extends Vue{
        @recharge.State('pager') pager:any
        @recharge.State('list') rechargeList:any
        @recharge.State('loading') loading:any
	    @Getter('type') type:any
        exicon:any = exicon
        time:any = []
        linkId:string = '' //快递员id
        get search() {
            let start = ''
            let end = ''
            if(this.time){
                start = this.time[0]
                end = this.time[1]
            }
            return {
                link: this.linkId,
                start: start,
                end: end,
                page: 1,
            }
        }
        get tablecolumn(){
            const result = [
	            {
		            prop: 'name',
		            name: 'name',
		            type: 'slot',
		            label: '快递员姓名',
	            },
	            {
		            prop: 'operationName',
		            name: 'operationName',
		            type: 'slot',
		            label: '操作人',
	            },
	            {
		            prop: 'amount',
		            type: 'text',
		            label: '充值金额',

	            },
	            {
		            prop: 'present',
		            type: 'text',
		            label: '赠送金额',

	            },
	            {
		            prop: 'total',
		            // name: 'total',
		            type: 'text',
		            label: '合计',

	            },
	            {
		            prop: 'ctime',
		            type: 'text',
		            label: '充值时间',
	            }
            ]
	        if (this.type !== 1) result.push({
		        prop: 'name',
		        name: 'operation',
		        type: 'slot',
		        label: '操作',

	        })
            return result;
        }
        @recharge.Action('getRechangeList') getRechangeList:any
        @recharge.Action('revocation') revocation:any
        created(){
            this.getList()
        }
        getList(){
            this.getRechangeList(this.search)
        }
        // 撤销充值
        async deleteRecharge(id:string){
            this.$confirm('确定撤销该条充值记录吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                const res = await this.revocation(id)
                if(res){
                    this.$message({  message: '撤销成功',type: 'success' });
                    this.getList()
                }
            }).catch(() => {

            });
        }
	    pagechange(page:any){
		    this.search.page = page[0].val;
		    this.getList();
	    }
        // 快递公司改变
        excomChange(e:string){
            this.linkId = e
        }
    }
